import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../App';
import { OnboardingContainer } from '../../common/components/OnboardingContainer';
import { InviteMobile } from './components/InviteMobile';
import { InvitePc } from './components/InvitePC';
import { appRoutes } from '../../AppRoutes';
import { useNavigate } from 'react-router-dom';
import { getInviteDetails, getUser, postAcceptInvite } from '../../common/api/apiClient';
import { getSavedAuth } from '../../common/utils/storage';
import { doRedirect } from '../../common/utils/utils';
import { useTrack } from '@hackler/react-sdk';

export const Invite: React.FC = () => {
  const { isMobile, redirect } = useContext(AppContext);
  const navigate = useNavigate();
  const track = useTrack();

  useEffect(() => {
    track({ key: 'view_invitation_link' });
    const auth = getSavedAuth();
    if (auth) {
      getUser(auth?.access_token).then(user => {
        if (user.companies.length) {
          doRedirect(redirect, auth);
        }
      });
    }
  }, []);

  const moveStep = () => {
    track({ key: 'click_invitaion_workspaces_create' });
    navigate(appRoutes.createCompany.path());
  };

  const handleAccept = async (inviteLink: string) => {
    const token = inviteLink.split('/').pop();
    track({ key: 'click_workspaces_enter' });

    if (!token) return;

    try {
      const res = await getInviteDetails(token);
      if (!res) {
        alert('유효하지 않은 초대장입니다.');
        return;
      }
      const auth = getSavedAuth();
      if (!auth) return;

      try {
        await postAcceptInvite(token);
        doRedirect(redirect, auth);
      } catch (e) {
        console.error(e);
      }
    } catch {
      alert('유효하지 않은 초대장입니다.');
    }
  };

  const handleInputClick = () => {
    console.log('Input clicked');
    track({ key: 'click_input_invitation_link' });
  };

  return (
    <OnboardingContainer step={'invite'}>
      {isMobile ? (
        <InviteMobile moveStep={moveStep} handleAccept={handleAccept} handleInputClick={handleInputClick} />
      ) : (
        <InvitePc moveStep={moveStep} handleAccept={handleAccept} handleInputClick={handleInputClick} />
      )}
    </OnboardingContainer>
  );
};
